// extracted by mini-css-extract-plugin
export var rateTable = "_61-0";